import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  AppDataService,
  GlobalVariablesService,
  StepRequest,
  StepResponse,
  StepsService
} from '@tmhcc-ng-lib/data-service';
import { StepNevigationService } from '../nevigation/step-nevigation.service';
import { Status } from '@tmhcc-ng-lib/models';

export class BasePendingPolicyComponent {
  public policyInfo: StepResponse;
  public siteCoreData;
  public occupied: string;
  public construction: string;
  public hydrant: string;
  public secured = {
    fenced: false,
    alarm: false,
    watchman: false,
    lighting: false,
    none: false
  };
  constructor(
    protected loaderService: LoaderService,
    protected appDataService: AppDataService,
    protected stepsService: StepsService,
    protected globalVariables: GlobalVariablesService,
    protected stepNevigationService: StepNevigationService
  ) {}

  callNgOnInit() {
    this.appDataService.showSummary.next(true);
    this.appDataService.stepsSitecoreContent.next();
    this.appDataService.summarySitecoreContent.next();
    this.appDataService.getStepsSitecoreData().subscribe(res => {
      this.loaderService.show();
      if (res) {
        this.siteCoreData = res;
      }
    });
    let payload: StepRequest = {
      policyId: this.globalVariables.policyId,
      versionNum: this.globalVariables.policyVersionId
    };
    this.appDataService.fetchAndPublishPolicyDetails(payload);
    this.appDataService.getPolicyDetails().subscribe(res => {
      if (res) {
        // if (
        //   res.SummaryDetails.SummaryPendingItem.PolicyStatus !=
        //   Status.PendingReview
        // ) {
        //   this.stepNevigationService.stepNevigation(res, true);
        // }
        this.policyInfo = res;
        this.jositeDetails();
        setTimeout(() => {
          this.loaderService.hide();
        }, 300);
      }
    });
  }

  jositeDetails() {
    if (
      this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_OccupancyYN == 'No'
    ) {
      this.occupied = 'No';
    } else {
      this.occupied = 'Yes';
    }
    if (
      this.policyInfo?.PolicyDetails?.Rating
        .BuildersRisk_ConstructionStartedYN == 'No'
    ) {
      this.construction = 'No';
    } else {
      this.construction = 'Yes';
    }
    if (this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_HydrantYN == 'No') {
      this.hydrant = 'No';
    } else {
      this.hydrant = 'Yes';
    }

    if (
      this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_SecuredFenced ==
      'True'
    ) {
      this.secured.fenced = true;
    } else {
      this.secured.fenced = false;
    }
    if (
      this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_SecuredAlarm == 'True'
    ) {
      this.secured.alarm = true;
    } else {
      this.secured.alarm = false;
    }
    if (
      this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_SecuredWatchman ==
      'True'
    ) {
      this.secured.watchman = true;
    } else {
      this.secured.watchman = false;
    }
    if (
      this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_SecuredLighting ==
      'True'
    ) {
      this.secured.lighting = true;
    } else {
      this.secured.lighting = false;
    }
    if (
      this.policyInfo?.PolicyDetails?.Rating.BuildersRisk_SecuredNone == 'True'
    ) {
      this.secured.none = true;
    } else {
      this.secured.none = false;
    }
  }
}
